import React, { useEffect } from "react";
import "./Pricing.css";
import sal from "sal.js";
import "../../../node_modules/sal.js/dist/sal.css";

function Pricing() {
  return (
    <div className="pricing">
      <h2>Our Categories</h2>
      <div className="image-gallery">
        <div
          data-sal-duration="1200"
          data-sal="slide-right"
          data-sal-delay="100"
          data-sel-easing="ease-out-bounce"
          data-sal-repeat="true"
          className="image-box"
        >
          <img
            src="https://images.unsplash.com/photo-1512258847512-e20a0714d631?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=725&q=80"
            alt="img.jpg"
          />
          <div className="overlay">
            <div className="details">
              <h3 className="title">
                <a href="#">Lorem Ipsum</a>
              </h3>
              <p className="category">
                <a href="#">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Mauris eget risus suscipit, pulvinar ipsum eget, pharetra
                  libero. Maecenas viverra nisi et metus interdum, ut maximus
                  nibh egestas. Integer velit turpis, placerat a arcu non,
                  finibus bibendum nibh. Pellentesque finibus, est at efficitur
                  vestibulum, ante diam venenatis mauris, scelerisque pharetra
                  metus turpis eu ipsum.
                </a>
              </p>
            </div>
          </div>
        </div>
        <div
          data-sal-duration="1200"
          data-sal="slide-left"
          data-sal-delay="100"
          data-sel-easing="ease-out-bounce"
          data-sal-repeat="true"
          className="image-box"
        >
          <img
            src="https://images.unsplash.com/photo-1526634027863-aacf61c59cae?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=435&q=80"
            alt="img.jpg"
          />
          <div className="overlay">
            <div className="details">
              <h3 className="title">
                <a href="#">Lorem Ipsum</a>
              </h3>
              <p className="category">
                <a href="#">Category</a>
              </p>
            </div>
          </div>
        </div>
        <div
          data-sal-duration="1200"
          data-sal="slide-left"
          data-sal-delay="100"
          data-sel-easing="ease-out-bounce"
          data-sal-repeat="true"
          className="image-box"
        >
          <img
            src="https://images.unsplash.com/photo-1441823120971-04969db3f294?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
            alt="img.jpg"
          />
          <div className="overlay">
            <div className="details">
              <h3 className="title">
                <a href="#">Lorem Ipsum</a>
              </h3>
              <p className="category">
                <a href="#">Category</a>
              </p>
            </div>
          </div>
        </div>
        <div
          data-sal-duration="1200"
          data-sal="slide-left"
          data-sal-delay="100"
          data-sel-easing="ease-out-bounce"
          data-sal-repeat="true"
          className="image-box"
        >
          <img
            src="https://images.unsplash.com/photo-1499092346589-b9b6be3e94b2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=871&q=80"
            alt="img.jpg"
          />
          <div className="overlay">
            <div className="details">
              <h3 className="title">
                <a href="#">Lorem Ipsum</a>
              </h3>
              <p className="category">
                <a href="#">Category</a>
              </p>
            </div>
          </div>
        </div>
        <div
          data-sal-duration="1200"
          data-sal="slide-left"
          data-sal-delay="100"
          data-sel-easing="ease-out-bounce"
          data-sal-repeat="true"
          className="image-box"
        >
          <img
            src="https://images.unsplash.com/photo-1503639500730-ff76f54fee06?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
            alt="img.jpg"
          />
          <div className="overlay">
            <div className="details">
              <h3 className="title">
                <a href="#">Lorem Ipsum</a>
              </h3>
              <p className="category">
                <a href="#">Category</a>
              </p>
            </div>
          </div>
        </div>
        <div
          data-sal-duration="1200"
          data-sal="slide-right"
          data-sal-delay="100"
          data-sel-easing="ease-out-bounce"
          data-sal-repeat="true"
          className="image-box"
        >
          <img
            src="https://images.unsplash.com/photo-1483653085484-eb63c9f02547?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
            alt="img.jpg"
          />
          <div className="overlay">
            <div className="details">
              <h3 className="title">
                <a href="#">Lorem Ipsum</a>
              </h3>
              <p className="category">
                <a href="#">Category</a>
              </p>
            </div>
          </div>
        </div>
        <div data-sal-duration="1200"
          data-sal="slide-right"
          data-sal-delay="100"
          data-sel-easing="ease-out-bounce"
          data-sal-repeat="true" className="image-box">
          <img
            src="https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
            alt="img.jpg"
          />
          <div className="overlay">
            <div className="details">
              <h3 className="title">
                <a href="#">Lorem Ipsum</a>
              </h3>
              <p className="category">
                <a href="#">Category</a>
              </p>
            </div>
          </div>
        </div>
        <div data-sal-duration="1200"
          data-sal="slide-left"
          data-sal-delay="100"
          data-sel-easing="ease-out-bounce"
          data-sal-repeat="true" className="image-box">
          <img
            src="https://images.unsplash.com/photo-1534430480872-3498386e7856?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
            alt="img.jpg"
          />
          <div className="overlay">
            <div className="details">
              <h3 className="title">
                <a href="#">Lorem Ipsum</a>
              </h3>
              <p className="category">
                <a href="#">Category</a>
              </p>
            </div>
          </div>
        </div>
        <div data-sal-duration="1200"
          data-sal="slide-right"
          data-sal-delay="100"
          data-sel-easing="ease-out-bounce"
          data-sal-repeat="true" className="image-box">
          <img
            src="https://images.unsplash.com/photo-1441823120971-04969db3f294?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
            alt="img.jpg"
          />
          <div className="overlay">
            <div className="details">
              <h3 className="title">
                <a href="#">Lorem Ipsum</a>
              </h3>
              <p className="category">
                <a href="#">Category</a>
              </p>
            </div>
          </div>
        </div>
        <div data-sal-duration="1200"
          data-sal="slide-right"
          data-sal-delay="100"
          data-sel-easing="ease-out-bounce"
          data-sal-repeat="true" className="image-box">
          <img
            src="https://images.unsplash.com/photo-1528055823578-1c18ae59ef8c?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=703&q=80"
            alt="img.jpg"
          />
          <div className="overlay">
            <div className="details">
              <h3 className="title">
                <a href="#">Lorem Ipsum</a>
              </h3>
              <p className="category">
                <a href="#">Category</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pricing;
